import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Search = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [value, setValue] = useState("");
  const [placeholder, setPlaceholder] = useState(t("search.placeholder"));
  const [focused, setFocused] = useState(false);
  const [hashtags, setHashtags] = useState([]);

  const popularKeys = [
    "search.popular.cashier",
    "search.popular.cameraOperator",
    "search.popular.deliveryAssistant",
    "search.popular.storekeeper",
    "search.popular.manager",
  ];

  const translatedHashtags = popularKeys.map((key) => `* ${t(key)}`);

  useEffect(() => {
    let index = 0;
    const interval = setInterval(() => {
      if (!focused && value.trim() === "") {
        index = (index + 1) % translatedHashtags.length;
        setPlaceholder(translatedHashtags[index]);
      }
    }, 3000);
    return () => clearInterval(interval);
  }, [focused, value, translatedHashtags]);

  const updateHashtags = (searches) => {
    const tags = Object.entries(searches)
      .filter(([_, count]) => count >= 3)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 10)
      .map(([term]) => term);

    setHashtags(tags);
  };

  useEffect(() => {
    const searches = JSON.parse(localStorage.getItem("searches") || "{}");
    updateHashtags(searches);
  }, []);

  const handleSearch = () => {
    const trimmedValue = value.trim();
    if (!trimmedValue) return;

    // если введено только число — значит, это ID вакансии
    if (/^\d+$/.test(trimmedValue)) {
      navigate(`/vacancy/${trimmedValue}`);
      return;
    }

    // стандартное поведение (поиск по тексту)
    let searches = JSON.parse(localStorage.getItem("searches") || "{}");
    searches[trimmedValue] = (searches[trimmedValue] || 0) + 1;
    localStorage.setItem("searches", JSON.stringify(searches));
    updateHashtags(searches);

   navigate(`/search?q=${encodeURIComponent(trimmedValue)}`);

  };

  return (
    <section className="flex z-10 justify-start items-center w-full px-2 max-sm:p-0 gap-6">
      <div className="flex w-full justify-start max-sm:justify-center items-center relative z-50">
        <input
          type="search"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          placeholder={!focused ? placeholder : ""}
          className="w-full text-[18px] py-2 px-5 h-[50px] rounded-[30px] outline-none border-[3px] border-transparent transition-all duration-200 focus:border-[#006674] max-sm:rounded-[30px] shadow-2xl focus:shadow-[#006674] placeholder:text-gray-400"
        />

        <button
          onClick={handleSearch}
          className="right-1 justify-center items-center absolute w-[40px] h-[40px] max-md:flex hidden rounded-[30px] border-0 cursor-pointer shadow-[0_0_20px_slate-600] bg-[#006674] text-white text-[18px] transition-all duration-200 hover:bg-[#848484]"
        >
          <FontAwesomeIcon icon={faSearch} />
        </button>
      </div>

      <button
        onClick={handleSearch}
        className="py-2 px-6 max-md:hidden rounded-[30px] border-0 cursor-pointer shadow-[0_0_20px_slate-600] bg-[#006674] text-white text-[18px] h-[50px] transition-all duration-200 hover:bg-[#848484]"
      >
        {t("search.button")}
      </button>
    </section>
  );
};

export default Search;
